<template lang="pug">
  button.button.is-flex.is-centered(
    :type="type"
    :class="compositeClass"
    :disabled="disabled"
    @click="onClick"
  )
    slot
    span(v-if="text") {{ text }}
</template>

<script>
export default {
  name: 'AppButton',
  props: {
    text: {
      type: String,
      default: '',
    },
    type: {
      type: String,
      default: null,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    loading: {
      type: Boolean,
      default: false,
    },
    required: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    compositeClass() {
      return { 'is-loading': this.loading };
    },
  },
  methods: {
    onClick(event) {
      this.$emit('click', event);
    },
  },
};
</script>

<style lang="stylus" scoped>
.button
  position relative
  font-size 1.25rem
  border-radius 4px
  box-shadow 0 3px 6px 0 rgba(0, 0, 0, 0.16)
  background-color transparent
  width 100%
  padding 12px 24px
  font-family OpenSans
  font-weight 500
  line-height 1.33
  text-transform capitalize
  outline 0
  text-decoration none
  border none
  cursor pointer

.button.is-primary
  background #026fc2
  color #ffffff

.button.is-danger
  background hsl(348, 100%, 61%)
  color #fff

.button.is-loading
  color transparent
  pointer-events none
  opacity .5

.button.is-loading::after
  position absolute
  animation spinAround .5s infinite linear
  border 2px solid #dbdbdb
  border-radius 100%
  border-right-color transparent
  border-top-color transparent
  content ''
  display block
  height 1em
  width 1em

@keyframes spinAround
  from
    transform: rotate(0deg)
  to
    transform: rotate(359deg)
</style>
